// ============================================================
// 后台静态路由
// 业务菜单走 fetchUserMenus（user/info.menus）→ 单 Layout 叶子路由
// 这里只放跟权限无关、固定不变的少量路由
// ============================================================
import type { RouteRecordRaw } from "vue-router";

export const staticRoutes: RouteRecordRaw[] = [
    {
        // 入口 / 直接重定向到 /login：登录后由登录页用 redirect query 回跳目标页，
        // 避免依赖 dynamic 路由加载时序（业务 Layout 在 fetchUserMenus 完成前不存在），
        // 防止 Vue Router warn "No match" + 错误跳到 /404。
        path: "/",
        redirect: "/login",
        meta: { hidden: true },
    },
];
